module.exports = __webpack_public_path__ + "static/media/dana.9a599d13.jpeg";